import { render, staticRenderFns } from "./SDARelatedDeliveries.vue?vue&type=template&id=689b8925"
import script from "./SDARelatedDeliveries.vue?vue&type=script&lang=js"
export * from "./SDARelatedDeliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports